import api from "@/router/api"

export default {

	updateRecordGeneralData({commit}, payload){
		return new Promise((resolve, reject) => {
			api.childrenInstallationsDocuments.updateRecordGeneralData(payload)
			.then(response => {
				resolve(response.data.data)
			})
			.catch(error => {
				reject({
					message: 'Ocurrió un problema al obtener la instalación',
				})
			})
		})
	},
	createRecordGeneralData({commit}, payload){
		return new Promise((resolve, reject) => {
			api.childrenInstallationsDocuments.createRecordGeneralData(payload)
			.then(response => {
				resolve(response.data.data)
			})
			.catch(error => {
				reject({
					message: 'Ocurrió un problema al obtener la instalación',
				})
			})
		})
	},
	getDocumentsList({commit}, payload){
		return new Promise((resolve, reject) => {
			api.childrenInstallationsDocuments.getDocumentsListByRoute(payload.id, payload)
			.then(response => {
				resolve(response.data.data)
				commit('SET_DOCUMENTS_BY_ROUTE_PROVIDER_CONTRACT_EE', response.data.data)
				commit('SET_DOCUMENTS_BY_ROUTE_SPECIFIC_PREVENTION', response.data.data)
				commit('SET_DOCUMENTS_BY_ROUTE_IDENTIFICATION_RISK_EE', response.data.data)
				commit('SET_DOCUMENTS_BY_ROUTE_WORKPLACE_EE', response.data.data)
				commit('SET_DOCUMENTS_BY_ROUTE_EMERGENCY_PLAN_EE', response.data.data)
				commit('SET_DOCUMENTS_BY_ROUTE_DOCUMENTS_ACAE', response.data.data)
				commit('SET_DOCUMENTS_BY_ROUTE_DOCUMENTS_MANUALPROJECT', response.data.data)
				commit('SET_DOCUMENTS_BY_ROUTE_DOCUMENTS_MAINTENANCE_INSPECTION', response.data.data)
				commit('SET_DOCUMENTS_BY_ROUTE_DOCUMENTS_ORDER', response.data.data)
				commit('SET_DOCUMENTS_BY_ROUTE_DOCUMENTS_OCA', response.data.data)
				commit('SET_DOCUMENTS_BY_ROUTE_DOCUMENTS_MAINTENANCE', response.data.data)
				commit('SET_DOCUMENTS_BY_ROUTE_DOCUMENTS_MAINTENANCE_INSITU', response.data.data)
				commit('SET_DOCUMENTS_BY_ROUTE_DOCUMENTS_MAINTENANCE_INVIGILANDO', response.data.data)
				commit('SET_DOCUMENTS_BY_ROUTE_DOCUMENTS_MAINTENANCE_ATEX', response.data.data)
			})
			.catch(error => {
				reject({
					message: 'Ocurrió un problema al obtener el listado de documentos',
				})
			})
		})
	},
	uploadDocuments({commit}, payload){
		return new Promise((resolve, reject) => {
			api.childrenInstallationsDocuments.uploadDocuments(payload.id, payload)
			.then(response => {
				resolve(response.data.data)
			})
			.catch(error => {
				reject({
					message: 'Ocurrió un problema al obtener el listado de documentos',
				})
			})
		})
	},
	listAllRecords({commit}, payload){
		return new Promise((resolve, reject) => {
			api.childrenInstallationsDocuments.listAllRecords(payload.id, payload)
			.then(response => {
				resolve(response.data.data)
			})
			.catch(error => {
				reject({
					message: 'Ocurrió un problema al obtener el listado de documentos',
				})
			})
		})
	},
	deleteRecord({commit}, payload) {
		return new Promise((resolve, reject) => {
			api.childrenInstallationsDocuments.deleteRecord(payload.id, payload)
			.then(response => {
				const {data} = response.data

				resolve(data)
			})
			.catch(() => {
				reject({
					message: 'Error al eliminar el registro.',
				})
			})
		})
	},
	deleteDocument({commit}, payload) {
		return new Promise((resolve, reject) => {
			api.childrenInstallationsDocuments.deleteDocument(payload)
				.then(response => {
					const {data} = response.data
					resolve(data)
				})
				.catch(() => {
					reject({
						message: 'Error al eliminar el registro.',
					})
				})
		})
	},
	deleteAllDocuments({commit}, payload) {
		return new Promise((resolve, reject) => {
			api.childrenInstallationsDocuments.deleteAllDocuments(payload)
			.then(response => {
				const {data} = response.data
				resolve(data)
			})
			.catch(() => {
				reject({
					message: 'Error al eliminar el registro.',
				})
			})
		})
	},
	setInspectionsByMaintenance({commit}, payload){
		commit('SET_DOCUMENT_INSPECTIONS', payload.data)
	},
	setInSituByMaintenance({commit}, payload){
		commit('SET_DOCUMENT_INSITU', payload.data)
	},
	setAtexByMaintenance({commit}, payload){
		commit('SET_DOCUMENT_ATEX', payload.data)
	},
	setInvigilandoByMaintenance({commit}, payload){
		commit('SET_DOCUMENT_INVIGILANDO', payload.data)
	},
	setActiveMaintenance({commit}, payload){
		commit('SET_ACTIVE_MAINTENANCE', payload.data)
	},
}
